import { render } from "./AppleSwiper.vue?vue&type=template&id=61b3430c&scoped=true"
import script from "./AppleSwiper.vue?vue&type=script&lang=js"
export * from "./AppleSwiper.vue?vue&type=script&lang=js"

import "./AppleSwiper.vue?vue&type=style&index=0&id=61b3430c&lang=scss&scoped=true"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61b3430c"]])

export default __exports__